import { createContext } from 'react';

interface IHubListenningContextProps {
	listenedAuth: string;
	listenedAuthError: string;
}

export const HubListenningContext = createContext<IHubListenningContextProps>({
	listenedAuth: '',
	listenedAuthError: ''
});